<mat-card *ngIf="cameras.length !== 0" class="cont">
  <mat-card-content>
    <div class="view-cameras-row">
      <button mat-button color="success" (click)="viewCameras = !viewCameras">
        <ng-container *ngIf="!viewCameras; else cameraOpen">
          <sn-icon>play_arrow</sn-icon>
          &nbsp;{{ 'communication.chat.viewCameras' | t }}
        </ng-container>
        <ng-template #cameraOpen>
          <sn-icon fontSet="fal" fontIcon="fa-xmark"></sn-icon>
          &nbsp;{{ 'communication.chat.hideCameras' | t }}
        </ng-template>
      </button>
    </div>
    <div class="view-cameras-row" *ngIf="viewCameras">
      <div class="fs-col-md-6 fs-mt-2" *ngFor="let camera of cameras">
        <sn-audit-camera-stream-view  
          class="share-camera"
          *ngIf="camera"
          [autoplay]="true"
          [camera]="camera"
          [controls]="true"
        >
        </sn-audit-camera-stream-view>
      </div>
    </div>
  </mat-card-content>
</mat-card>
